module.exports = __webpack_public_path__ + "static/media/kinoImage2.48448897.png";